export enum TicketTier {    
    NA = 0,
    Tier1 = 1,
    Tier2 = 2,
    Tier3 = 3
}